import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApi } from '../../../network/itemList';
const AdditionalCostsList = ({ setDataSource, dataSource, t, form }) => {
  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.companyName,
      dataIndex: 'company_name',
      render: (text, record, index) => (
        <Input
          placeholder={t.companyName}
          style={{ width: '100%' }}
          value={record.company_name}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              company_name: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.designation,
      dataIndex: 'designation',
      render: (text, record, index) => (
        <Input
          placeholder={t.designation}
          style={{ width: '100%' }}
          value={record.designation}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              designation: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.salary,
      dataIndex: 'salary',
      render: (text, record, index) => (
        <Input
          placeholder={t.salary}
          style={{ width: '100%' }}
          type="number"
          min={0}
          value={record.salary}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              salary: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.totalExperience,
      dataIndex: 'total_experience',
      render: (text, record, index) => (
        <Input
          placeholder={t.totalExperience}
          style={{ width: '100%' }}
          type="number"
          min={0}
          value={record.total_experience}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              total_experience: e.target.value,
            };
            setDataSource(newDataSource);
          }}
        />
      ),
    },

    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default AdditionalCostsList;
